import { jsx as _jsx } from "react/jsx-runtime";
export const DropdownDivider = () => _jsx("div", { className: "my-1 h-px bg-gray-100 dark:bg-gray-600" });
